import {Marker, ZOOM_BREAK} from "@/models/Marker";

export class SensorMarker extends Marker{

  constructor(data, map, callback) {
    super(data, map, callback)
  }

  getIconSize () {
    return 54;
  }

  getIconName (){
    return `q${this.data.airQualityLevel}`;
  }

  getIconOpacity (zoom){
    return zoom < ZOOM_BREAK ? (zoom / ZOOM_BREAK) * 0.6 : 1;
  }
}
